import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class RouteTracePreferenceService {
  private readonly storagePrefix = 'tpslRoute.showRouteTrace.';

  constructor(private authenticationService: AuthenticationService) {}

  getForCurrentUser(): boolean {
    const key = this.getStorageKey();
    if (key === null) {
      return true;
    }

    try {
      const stored = localStorage.getItem(key);
      return stored !== 'false';
    } catch (error) {
      return true;
    }
  }

  setForCurrentUser(visible: boolean): void {
    const key = this.getStorageKey();
    if (key === null) {
      return;
    }

    try {
      localStorage.setItem(key, visible ? 'true' : 'false');
    } catch (error) {
      // Storage can be unavailable in private or restricted browser contexts.
    }
  }

  private getStorageKey(): string {
    const user = this.authenticationService.currentUserValue;
    if (user === null || user === undefined) {
      return null;
    }

    if (typeof user.UserID === 'number' && isFinite(user.UserID) && user.UserID > 0) {
      return this.storagePrefix + 'id:' + user.UserID.toString();
    }

    if (user.UserName !== null && user.UserName !== undefined && user.UserName !== '') {
      return this.storagePrefix + 'name:' + encodeURIComponent(user.UserName);
    }

    return null;
  }
}
